import React from 'react';
import {Col, Form} from 'react-bootstrap';
import ManualPostalAddress from './ManualPostalAddress';


class AddressForm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showManualAddress: false
        };
        this.widget = null
        this.full_address = React.createRef()
        this.address_line_1 = React.createRef()
        this.address_line_2 = React.createRef()
        this.suburb = React.createRef()
        this.city = React.createRef()
        this.postcode = React.createRef()

    }

    componentDidMount() {
        var script = document.createElement('script');
        script.src = 'https://api.addressfinder.io/assets/v3/widget.js';
        script.async = true;
        script.onload = this.loadWidget
        document.body.appendChild(script);
    }

    componentWillUnmount() {
        if (this.widget) {
            this.widget.destroy()
            this.widget = null
        }
    }

    loadWidget = () => {
        if (window.AddressFinder && window.AddressFinder.Widget) {
            this.widget = new window.AddressFinder.Widget(
                document.getElementById('full_address'),
                '7XRVYC8PJU43MABD6W9H',
                'NZ',
                {'empty_content': 'Address not found. Please enter address manually.'}
            );
            if (this.widget && typeof this.widget.on === 'function') {
                this.widget.on('result:select', (fullAddress, metaData) => {
                    if (this.props.addressType == 'risk') {
                        this.props.handleChangeValue('full_address', metaData.a);
                    } else if (this.props.addressType == 'postal') {
                        this.props.updatePostalAddress('postalAddress.fullAddress', metaData.a);
                    }
                    new window.AddressFinder.NZSelectedAddress(fullAddress, metaData);
                    this.props.handleChangeValue('addressLine1', metaData.address_line_1);
                    this.props.handleChangeValue('addressLine2', metaData.address_line_2 || '');
                    this.props.handleChangeValue('suburb', metaData.selected_suburb ? metaData.selected_suburb : metaData.selected_city);
                    this.props.handleChangeValue('city', metaData.selected_city);
                    this.props.handleChangeValue('postcode', metaData.postcode);
                    this.props.callAddressSearch(metaData.address_line_1, metaData.address_line_2 || '', metaData.selected_suburb ? metaData.selected_suburb : metaData.selected_city, metaData.postcode, true);
                });
            }
        }
    }

    handleAddressChange = (e) => {
        const value = e.target.value;
        if (value === '') {
          console.log("empty address");
            this.props.handleChangeValue('addressLine1', '');
            this.props.handleChangeValue('addressLine2', '');
            this.props.handleChangeValue('suburb', '');
            this.props.handleChangeValue('city', '');
            this.props.handleChangeValue('postcode', '');
          if (this.props.fullAddressName === "full_address") {
            this.props.handleChangeValue(e.target.name, '');
          } else if (this.props.fullAddressName === "postalAddress.fullAddress") {
            this.props.updatePostalAddress(e.target.name, e.target.value);
          }
        } else {
          if (this.props.fullAddressName === "full_address") {
            this.props.handleChangeValue('uniqueAddressFound', false);
            this.props.handleChangeValue(e.target.name, e.target.value);
          } else if (this.props.fullAddressName === "postalAddress.fullAddress") {
            this.props.handleChangeValue('postalUniqueAddressFound', false);
            this.props.updatePostalAddress(e.target.name, e.target.value);
          }
    }
    }

    handleClick = () => {
        this.props.handleChangeValue('addressLine1', '');
        this.props.handleChangeValue('addressLine2','');
        this.props.handleChangeValue('suburb', '');
        this.props.handleChangeValue('city', '');
        this.props.handleChangeValue('postcode', '');
        this.setState({
            showManualAddress: true
        })
    };

    manualAddressHide = () => {
        this.setState({
            showManualAddress: false
        })
    };

    render() {
        return (
            <>
                {
                    this.state.showManualAddress && <>
                        <ManualPostalAddress
                            setParentManualAddressPopupShow={this.manualAddressHide}
                            parentManualAddressPopupShow={this.state.showManualAddress}
                            inputValues={this.props.inputValues}
                            handleChange={this.props.handleChange}
                            errors={this.props.errors}
                            handleChangeValue={this.props.handleChangeValue}
                            callAddressSearch={this.props.callAddressSearch}/>
                    </>

                }
                <div className="row">
                    <Form.Group as={Col} md="12">
                        <div style={{ display: 'flex',alignItems: 'center' }}>
                        <input
                            required
                            type="search"
                            id='full_address'
                            className="block w-full rounded-md py-1.5 pl-10 pr-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            style={{
                                overflow: 'hidden',
                                border: '1px #E5E7EB solid',
                                boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                                borderRadius: 6,
                                outline: 'none',
                                fontSize: 'inherit',
                                fontFamily: 'inherit',
                                fontWeight: 'inherit',
                                lineHeight: 'inherit',
                                width: '100%',
                                maxWidth: '300px',
                                height: '40px',
                                marginRight: '10px',
                                background: 'transparent',
                            }}
                            placeholder="Search address here..."
                            name={this.props.fullAddressName}
                            value={this.props.fullAddress}
                            onChange={this.handleAddressChange}
                          // disabled={!this.props.inputValues.regNumber}
                        /> {this.props.uniqueAddressFound && <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                                className="bi bi-check-circle" viewBox="0 0 16 16" style={{color: "green"}}>
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                            <path
                                d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
                        </svg>}

                        </div>
                        <Form.Control.Feedback type="invalid">
                            {this.props.errors.full_address}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <div style={{ padding: "10px", marginTop: "5px" }}>
                        <a
                            id="button-addon2"
                            onClick={this.handleClick}
                            style={{ textDecoration: 'underline', cursor: 'pointer',color:'#1851A3' }}
                        >  Enter address manually
                        </a>
                    </div>
                </div>

            </>
        )
    }
}

export default AddressForm;
